






























































































































































import {Component} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsActionBox from "@/design-system/patterns/JdsActionBox.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdiCodeBlock from "@/components/JdiCodeBlock.vue"

@Component({
    components: {JdiCodeBlock, JdiDocs, JdsGlyph, JdiPreview, JdsButton, JdsIcon, JdsActionBox, JdiStatus, JdiContent}
})
export default class Pipeline extends Vue {
    example3selecting = false
    example3selected = []
}
